import { LOCAL_STORAGE_KEYS } from "./localStorageKeys";
import { loadJsonFromLocalStorage, saveJsonToLocalStorage } from "./localStorageState";

export interface ReadSystemNotice {
  id: string;
  versionId: string;
  readAt: string; // ISO-timestamp
}

// Per gebruiker (of 'public') een lijst met gelezen meldingen.
type ReadStore = Record<string, ReadSystemNotice[]>;

const PUBLIC_USER_KEY = 'public';

const load = (): ReadStore =>
  loadJsonFromLocalStorage<ReadStore>(LOCAL_STORAGE_KEYS.SYSTEM_NOTICES_READ, {});

const resolveKey = (userKey?: string | null): string => userKey || PUBLIC_USER_KEY;

export const getReadSystemNoticeIds = (userKey?: string | null): Set<string> => {
  const store = load();
  const entries = store[resolveKey(userKey)] ?? [];
  return new Set(entries.map((entry) => entry.id));
};

export const markSystemNoticeRead = (
  notice: { id: string; versionId: string },
  userKey?: string | null,
): void => {
  const key = resolveKey(userKey);
  const store = load();
  const entries = store[key] ?? [];
  const readAt = new Date().toISOString();

  const existing = entries.find((entry) => entry.id === notice.id);
  if (existing) {
    store[key] = entries.map((entry) =>
      entry.id === notice.id ? { ...entry, versionId: notice.versionId, readAt } : entry,
    );
  }
  else {
    store[key] = [...entries, { id: notice.id, versionId: notice.versionId, readAt }];
  }

  saveJsonToLocalStorage(LOCAL_STORAGE_KEYS.SYSTEM_NOTICES_READ, store);
};
